var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-textarea",
    _vm._b(
      {
        attrs: {
          outlined: "",
          rules: _vm.rules,
          "auto-grow": "",
          counter: "",
          value: _vm.value
        },
        on: {
          input: _vm.handleChange,
          paste: function($event) {
            return _vm.$emit("paste", $event)
          },
          click: function($event) {
            return _vm.$emit("click", $event)
          },
          keypress: function($event) {
            return _vm.$emit("keypress", $event)
          }
        }
      },
      "v-textarea",
      _vm.$attrs,
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }